import {
  PublisherWebsiteFilterField,
  PublisherWebsiteFilterFieldMap,
} from 'respona_api/generated/order-publisher_pb';

type FilterFieldType = {
  label: string;
  value: PublisherWebsiteFilterFieldMap[keyof PublisherWebsiteFilterFieldMap];
  type: 'string' | 'boolean' | 'number' | 'enum' | 'date' | 'enumString';
  inputOptions?: { value: string | number; label: string }[];
};

export const getPublisherWebsiteFilterFields = (): FilterFieldType[] => {
  return [
    {
      label: 'Domain',
      type: 'string',
      value: PublisherWebsiteFilterField.STRING_WEBSITE_DOMAIN,
    },
    {
      label: 'Website',
      type: 'string',
      value: PublisherWebsiteFilterField.STRING_WEBSITE_NAME,
    },
    {
      label: 'Link Limit',
      type: 'number',
      value: PublisherWebsiteFilterField.NUMBER_WEBSITE_LINK_LIMIT,
    },
    {
      label: 'MOZ DA',
      type: 'number',
      value: PublisherWebsiteFilterField.NUMBER_WEBSITE_MOZ_DA,
    },
    {
      label: 'Semrush AS',
      type: 'number',
      value: PublisherWebsiteFilterField.NUMBER_WEBSITE_SEMRUSH_AS,
    },
    {
      label: 'Ahrefs DR',
      type: 'number',
      value: PublisherWebsiteFilterField.NUMBER_WEBSITE_AHREF_DR,
    },
    {
      label: 'Ahrefs Traffic',
      type: 'number',
      value: PublisherWebsiteFilterField.NUMBER_WEBSITE_AHREF_TRAFFIC,
    },
  ];
};
